















































































































































































































































































































































import Carrito from '@/components/Carrito.vue';
import CarritoOrdenes from '@/views/ordenesCompra/CarritoOrdenes.vue';
import FormProfiles from '@/components/FormProfiles.vue';
import Perfil from '@/views/Perfil.vue';
import Pedidos from '@/views/pedidos/Pedidos.vue';
import Change from '@/views/Change.vue';
import Contratos from '@/views/Contratos.vue';
import Recibos from '@/views/recibos/Recibo.vue';
import AdminDialog from '@/components/AdminDialog.vue';
import Configuraciones from '@/components/Configuraciones.vue';
import CuentaCorriente from '@/views/Resumen.vue';
import Granos from '@/views/Granos.vue';
import Posiciones from '@/views/PosicionStockVentas.vue';
import axios from 'axios';
import Entidad from '@/models/Entidad';

export default {
	name: 'Main',
	inject: ['responsive'],
	components: {
		Carrito,
		//FormProfiles,
		//Pedidos,
		Perfil,
		Change,
		Configuraciones,
		CuentaCorriente,
		Granos,
		//ChangeProfiles,
		AdminDialog,
		Contratos,
		Posiciones,
		Recibos,
		CarritoOrdenes,
	},
	data() {
		return {
			cuit: this.$store.state.config.cuit,
			publicPath: process.env.BASE_URL,
			showMenu: false,
			innerDrawer: false,
			showConfig: false,
			showSesion: false,
			showActiva: false,
			profileDialog: false,
			showAdminDialog: false,
			visibleCarrito: false,
			visibleCarritoOrdenes: false,
			showChange: false,
			window: '',
			loadingentidad: false,
			menuActive: '/1/dashboard',
			loadingMain: false,
			input: '',
			visible: false,
			//menuEntidadesLogin: [],
		};
	},
	watch: {
		$route(): void {
			console.log('menu activo', this.menuActive);
			this.showMenu = false;
		},
		/*entidadesLogin(entidadesLogin): void {
			this.menuEntidadesLogin = entidadesLogin;
		},*/
	},
	computed: {
		config() {
			return this.$store.state.config.config;
		},
		entity() {
			return this.$store.state.config.entidad;
		},
		responsiveValue() {
			return this.responsive.isMobile ? 'Mobile' : 'Desktop';
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile ? this.$store.state.perfil.activeProfile : null;
		},
		clienteProfile() {
			return parseInt(this.$route.path.slice(1, 2)) === 1;
		},
		perfiles: {
			get() {
				return this.$store.state.perfil.userdata.perfiles;
			},
			set(val) {
				this.$store.state.perfil.userdata.perfiles = val;
			},
		},
		isUserdata() {
			return Object.entries(this.$store.state.perfil.userdata).length !== 0;
		},
		isAuthenticated() {
			return this.$store.getters.isAuthenticated;
		},
		menu() {
			return this.$store.state.perfil.menu ? this.$store.state.perfil.menu : [];
		},
		firstName() {
			return this.$store.state.perfil.userdata.first_name || '';
		},
		lastName() {
			return this.$store.state.perfil.userdata.last_name || '';
		},
		userID() {
			return this.$store.state.perfil.userdata.username;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		isMobile() {
			return this.window.innerWidth < 480 ? true : false;
		},
		admin() {
			return this.$store.getters.isAdmin;
		},
		entidadesLogin() {
			return this.$store.state.perfil.entidadesLogin;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
		descEntidadSelected() {
			return this.$store.state.perfil.descEntidadSelected;
		},
		// entidades(): Entidad[] {
		// 	return this.$store.state.dashboard.entidades;
		// },
		filterEntidad(): void {
			/*return this.entidadesLogin.filter(enti => {
				return enti.descri_entidad.toLowerCase().includes(this.input.toLowerCase());
			});*/
			if (this.input) {
				return this.entidadesLogin.filter(item => {
					item.completo = item.descri_entidad + item.codigo_entidad;
					return this.input
						.toLowerCase()
						.split(' ')
						.every(v => item.completo.toLowerCase().includes(v));
				});
			} else return this.entidadesLogin;
		},
	},
	methods: {
		displayCarrito() {
			this.visibleCarrito = !this.visibleCarrito;
		},
		displayCarritoOrdenes() {
			this.visibleCarritoOrdenes = !this.visibleCarritoOrdenes;
		},
		callDoImprimir($document): void {
			switch (this.$route.path.substr(3, 3)) {
				case 'con':
					this.$refs.contratos.doImprimir($document);
					break;
				case 'gra':
					this.$refs.granos.doImprimir($document);
					break;
				case 'pos':
					this.$refs.posiciones.doImprimir($document);
					break;
				default:
					$document === 'zip' ? this.$refs.resumen.downloadFiles() : this.$refs.resumen.doImprimir($document);
					break;
			}
		},
		actionProfile(command): void {
			command === 'a' ? this.showProfile() : this.doLogout();
		},
		displayMenu(): void {
			this.showMenu = !this.showMenu;
		},
		displayConfig(): void {
			this.showConfig = !this.showConfig;
		},
		displaySession(activa: boolean): void {
			if (!localStorage.getItem('cambia-entidad')) this.$store.dispatch('setEntidadSelected', ''); // necesario para que no se loguee con la empresa q entro.
			this.$store.dispatch('setPorlets', []);
			const url = activa ? '/welcome/sessions' : '/welcome/new';
			this.$router.push(url);
		},
		changeEntidad(entidad: Entidad): void {
			if (!entidad.activa) return;
			this.loadingMain = true;
			this.menuActive = '/1/dashboard';
			axios.defaults.headers.common.Entity_ID = entidad.codigo_entidad;
			//if (this.responsive.isMobile) this.$store.dispatch('setEntidadSelected', entidad);
			this.$store.dispatch('setEntidadSelected', entidad);
			this.$checkCurrentRouteAndRedirect(this.$router, '/1/dashboard');
			//TODO: ver el tema de la ficha de granos.
			this.$store
				.dispatch('loadPorlets', {
					url: 'etenet_dashboard',
				})
				.then(() => {
					this.loadingMain = false;
				});

			this.innerDrawer = false;
			this.showMenu = false;
		},
		async doLogout(): Promise<void> {
			await this.$confirm('Su sesión se cerrará. ¿Desea continuar?', 'Atención', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: this.responsive.isMobile ? true : false,
			});
			await this.$store.dispatch('logout');
			this.$store.dispatch('reset');
			window.location.reload();
		},
		showProfile(): void {
			this.profileDialog = true;
		},
		onCloseProfile(): void {
			this.profileDialog = false;
		},
		changeAdminDialog(): void {
			this.showAdminDialog = !this.showAdminDialog;
		},
		onCloseAdminDialog(): void {
			this.showAdminDialog = false;
		},
		closeNovedad(): void {
			this.visible = false;
			localStorage.setItem('novedad_entidad', 'true');
		},
	},
	mounted() {
		this.visible = !localStorage.getItem('novedad_entidad'); // para el popover que anuncia el nuevo cambio de entidades
		if (this.isAuthenticated) {
			this.$store
				.dispatch('buscoEntidad', {
					cuit: this.$store.state.config.cuit,
				})
				.then(asd => {
					let params = {
						mobile: this.responsive.isMobile,
						cuit: this.$store.state.config.cuit,
						codent: this.$store.state.perfil.userdata.codent
							? this.$store.state.perfil.userdata.codent
							: this.entidadesLogin[0].codigo_entidad,
					};
					if (!this.entidadSelected) {
						this.$store.dispatch('getUserData', params).then(result => {
							axios.defaults.headers.common.Entity_ID = result.data.usuario.codent;
							this.perfiles = result.data.usuario.perfiles;
							if (this.activeProfile == null || this.activeProfile == 0) {
								// si es 0 el perfil no está definido
								if (this.perfiles.length === 1) {
									// si hay un unico perfil asumimos que es uno clientes
									this.activeProfile = this.perfiles[0].id;
									if (this.$route.name !== 'Dashboard') this.$router.push('/1/dashboard');
								}
							}
							if (this.$route.name !== 'Dashboard') this.$router.push(`/${this.activeProfile}/dashboard`);

							// pongo a la unica entidad como entidad seleccionada
							//this.$store.dispatch('setEntidadSelected', entidad);
							//seteo el codigo de entidad en el store
							//this.$store.dispatch('setEntidad', result.data.usuario.codent);

							this.window = window;
						});
					}
					//alert('que');
					//this.$router.push(`/${this.activeProfile}/dashboard`);
					if (this.admin) this.changeAdminDialog();
				});
		}
	},
};
